import { ref, watch, computed } from '@vue/composition-api';
import store from '@/store';

// Notification
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import { useToast } from 'vue-toastification/composition';

export default function useBiddersList() {

    // Use toast
    const toast = useToast();

    const refBidderListTable = ref(null);

    const styleColumns = {
        thClass: 'text-center',
        tdClass: 'text-center'
    }

    // Table Handlers
    let tableColumns = [
        { key: 'bidder_name', sortable: true, label: 'POSTOR', thClass: styleColumns.thClass },
        { key: 'ruc', sortable: true, label: 'RUC', ...styleColumns },
        { key: 'user_email', sortable: true, label: 'CONTACTO', thClass: styleColumns.thClass },
        { key: 'business_area_name', sortable: true, label: 'RUBRO', ...styleColumns },
        { key: 'approval_state_name', sortable: true, label: 'ESTADO <br/> DE HOMOLOGACIÓN', ...styleColumns },
        { key: 'tender_count', sortable: true, label: 'N° LICITACIONES <br/> PARTICIPADAS', ...styleColumns },
        { key: 'actions', sortable: false, label: 'OPCIONES', ...styleColumns }
    ];

    const perPage = ref(10);
    const totalBidders = ref(0);
    const currentPage = ref(1);
    const perPageOptions = [10, 25, 50, 100];
    const searchQuery = ref('');
    const sortBy = ref('createdAt');
    const isSortDirDesc = ref(true);

    const businessAreasFilter = ref(null);
    const approvalStatesFilter = ref(null);

    const dataMeta = computed(() => {
        const localItemsCount = refBidderListTable.value ? refBidderListTable.value.localItems.length : 0;
        return {
            from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: totalBidders.value,
        }
    });

    const refetchData = () => {
        refBidderListTable.value.refresh();
    };

    watch([currentPage, perPage, searchQuery, businessAreasFilter, approvalStatesFilter], () => {
        refetchData();
    });

    const fetchBidders = (ctx, callback) => {
        store
            .dispatch('app-bidder/fetchBidders', {
                q: searchQuery.value,
                perPage: perPage.value,
                page: currentPage.value,
                sortBy: sortBy.value,
                sortDesc: isSortDirDesc.value,

                businessAreas: businessAreasFilter.value,
                approvalStates: approvalStatesFilter.value,
            })
            .then(response => {
                const { bidders, total } = response.data;
                callback(bidders);
                totalBidders.value = total;
            })
            .catch(() => {
                toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Error al obtener la lista de postores',
                        icon: 'AlertTriangleIcon',
                        variant: 'danger'
                    }
                });
            })
    };

    return {
        fetchBidders,
        tableColumns,
        perPage,
        currentPage,
        totalBidders,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refBidderListTable,

        refetchData,

        // Extra Filters
        businessAreasFilter,
        approvalStatesFilter
    }
}